export const changeCompany = (() => {

    var compaines = document.getElementsByName("selectCompany");

    Array.from(compaines).forEach((company) => addEL(company));

    function addEL(company) {
      if (!company.hasAttribute("data-url")) return;

      company.addEventListener("change", function () {
        const newURL = this.getAttribute("data-url");
        window.location.href = newURL;
      });
    }

})();